"use client";

import styled from "styled-components";

type ColStylesProps = {
  columns: number;
};

export const Col = styled.div<ColStylesProps>`
  flex: 0 0 ${({ columns }) => (columns / 12) * 100}%;
  max-width: ${({ columns }) => (columns / 12) * 100}%;

  @media (max-width: 768px) {
    flex: 0 0 100%;
    max-width: 100%;
  }
`;
